import React from 'react';
import PropTypes from 'prop-types';

const SendLetter = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="Rectangle_487" width="22" height="22" rx="2" fill={color} opacity="0" />
      <g id="Stockholm-icons-_-Communication-_-Sending" transform="translate(1 1)">
        <rect id="bound" width="20" height="20" transform="translate(0)" fill="none" />
        <path id="Combined-Shape" d="M8,11.851l10.373-.972L8,9.906V5.688a.417.417,0,0,1,.588-.38L20.121,10.5a.417.417,0,0,1,0,.76L8.588,16.449A.417.417,0,0,1,8,16.069Z" transform="translate(-1.333 -0.879)" fill={color} fillRule="evenodd" />
        <path id="Combined-Shape-2" d="M3.333,14.333h.833a.833.833,0,1,1,0,1.667H3.333a.833.833,0,0,1,0-1.667Zm-2.5-4.167H4.167a.833.833,0,1,1,0,1.667H.833a.833.833,0,0,1,0-1.667ZM3.333,6h.833a.833.833,0,1,1,0,1.667H3.333A.833.833,0,1,1,3.333,6Z" transform="translate(0 -1)" fill={color} fillRule="evenodd" opacity="0.3" />
      </g>
    </svg>
  );
}

SendLetter.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

SendLetter.defaultProps = {
  color: '#000000',
  width: 22,
  height: 22,
};

export default SendLetter;



// WEBPACK FOOTER //
// ./src/components/Icons/SendLetter.jsx